module.exports = __webpack_public_path__ + "static/media/Risorsa 001.364bd53a.svg";